(function () {
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      maximumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2
    }).format(Number(cents || 0) / 100);
  }

  function updateOffer(offer) {
    var select = offer.querySelector('[data-bcf-cart-offer-select]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    if (!option) return;
    var anchor = Number(offer.dataset.anchorCents || 0);
    var anchorCompare = Number(offer.dataset.anchorCompareCents || Math.round(anchor * 1.25));
    var second = Number(option.dataset.priceCents || 0);
    var secondCompare = Number(option.dataset.compareCents || Math.round(second * 1.25));
    var offerDiscount = Math.round(Math.min(anchor, second) * 0.3);
    var pairTotal = anchor + second - offerDiscount;
    var totalSavings = anchorCompare + secondCompare - pairTotal;
    var image = offer.querySelector('[data-bcf-cart-offer-image]');
    if (image && option.dataset.image) image.src = option.dataset.image;
    var price = offer.querySelector('[data-bcf-cart-offer-price]');
    var compare = offer.querySelector('[data-bcf-cart-offer-compare]');
    var total = offer.querySelector('[data-bcf-cart-offer-total]');
    var savings = offer.querySelector('[data-bcf-cart-offer-savings]');
    if (price) price.textContent = money(second);
    if (compare) compare.textContent = money(secondCompare);
    if (total) total.textContent = money(pairTotal);
    if (savings) savings.textContent = money(totalSavings);
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-bcf-cart-offer-select]');
    if (!select) return;
    var offer = select.closest('[data-bcf-cart-offer]');
    if (offer) updateOffer(offer);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-bcf-cart-offer-form]');
    if (!form) return;
    var select = form.querySelector('[data-bcf-cart-offer-select]');
    var detail = { variant_id: select ? select.value : '', placement: 'cart_drawer' };
    window.dispatchEvent(new CustomEvent('bcf:cart-offer-add-clicked', { detail: detail }));
    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture('bcf_cart_offer_add_clicked', detail);
    }
  }, true);
})();
